import { ProjectInterface as IProject } from "../../models/interfaces/project.interface";
import { type } from '../utils/util';

export class ProjectsActions {
	static ADD_OR_UPDATE_PROJECT = type('ADD_OR_UPDATE_PROJECT');
	static ADD_MISS_ACTIVE_PROJECTS = type('ADD_MISS_ACTIVE_PROJECTS');
	static ADD_MISS_ARCHIVE_PROJECTS = type('ADD_MISS_ARCHIVE_PROJECTS');
	static ARCHIVE_PROJECT = type('ARCHIVE_PROJECT');
	static ACTIVATE_PROJECT = type('ACTIVATE_PROJECT');
	static REMOVE_ACTIVE_PROJECT = type('REMOVE_ACTIVE_PROJECT');
	static REMOVE_ARCHIVE_PROJECT = type('REMOVE_ARCHIVE_PROJECT');
  static SYNC_PROJECT = type('SYNC_PROJECT');
  static DELETE_PROJECT = type('DELETE_PROJECT');
  static DELETE_PROJECT_MONSTER = type('DELETE_PROJECT_MONSTER');
  static DELETE_ALL = type('DELETE_ALL');

	addOrUpdateProject(payload: { project: {} }) {
		return {
			type: ProjectsActions.ADD_OR_UPDATE_PROJECT,
			payload: payload
		};
	}

	syncProject(payload: {id: number, saved: boolean, project: {}}){
		return {
			type: ProjectsActions.SYNC_PROJECT,
			payload: payload
		}
	}

	addMissingActiveProjects(payload: { projects: IProject[] }){
		return {
			type: ProjectsActions.ADD_MISS_ACTIVE_PROJECTS,
			payload: payload
		}
	}

	addMissingArchiveProjects(payload: { projects: IProject[] }){
		return {
			type: ProjectsActions.ADD_MISS_ARCHIVE_PROJECTS,
			payload: payload
		}
	}

	removeActiveProject(payload: { project: IProject }){
		return {
			type: ProjectsActions.REMOVE_ACTIVE_PROJECT,
			payload: payload
		}
	}

	removeArchiveProject(payload: { project: IProject }){
		return {
			type: ProjectsActions.REMOVE_ARCHIVE_PROJECT,
			payload: payload
		}
	}

	activateProject(payload: { project: IProject }){
		return {
			type: ProjectsActions.ACTIVATE_PROJECT,
			payload: payload
		}
	}

	archiveProject(payload: { project: IProject }){
		return {
			type: ProjectsActions.ARCHIVE_PROJECT,
			payload: payload
		}
  }

  delete(payload: { projectId: number }) {
    return {
      type: ProjectsActions.DELETE_PROJECT,
      payload: payload
    }
  }

  deleteMonster(payload: { projectId: number; monsterId: number}) {
    return {
      type: ProjectsActions.DELETE_PROJECT_MONSTER,
      payload: payload
    }
  }

  deleteAll() {
    return {
      type: ProjectsActions.DELETE_ALL
    }
  }
}



// WEBPACK FOOTER //
// ./src/states/projects/projects.actions.ts